import { createContext, ReactNode, useContext } from 'react';
import { Portal } from '@radix-ui/react-portal';
import noop from 'lodash/noop';
import { ModalSize, MODAL_SIZES, ModalVariant, MODAL_VARIANTS } from './Modal.constants';

export const ModalContext = createContext({
  onClose: noop,
  withPortal: false,
  size: MODAL_SIZES.MEDIUM,
  variant: MODAL_VARIANTS.DEFAULT,
});
export const useModalContext = () => useContext(ModalContext);

type ModalProviderProps = {
  onClose: () => void;
  size: ModalSize;
  variant: ModalVariant;
  withPortal: boolean;
  children: ReactNode;
};

/** TODO: Make `isModalOpen` work correctly by returning `null` instead of `children` when it's `false`  */
export const ModalProvider = ({ children, ...rest }: ModalProviderProps) => {
  return (
    <ModalContext.Provider value={rest}>
      {rest.withPortal ? <Portal asChild>{children}</Portal> : children}
    </ModalContext.Provider>
  );
};
